import React from 'react';
import { Link } from 'react-router-dom';

const PoliticaCookies = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Política de Cookies</h1>
          
          <div className="prose prose-lg max-w-none text-gray-700">
            <p className="text-lg mb-6">
              El Centro de Estudios e Investigaciones para el Desarrollo Docente (CENID) utiliza cookies 
              y tecnologías similares para mejorar su experiencia en nuestro sitio web.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">¿Qué son las cookies?</h2>
            <p className="mb-6">
              Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita 
              un sitio web. Nos permiten reconocer su navegador y capturar y recordar cierta información 
              para mejorar su experiencia de navegación.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Tipos de cookies que utilizamos</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">1. Cookies Necesarias</h3>
            <p className="mb-4">
              Estas cookies son esenciales para el funcionamiento del sitio web y no pueden ser 
              deshabilitadas. Incluyen:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Cookies de sesión para mantener su navegación</li>
              <li>Cookies de preferencias de idioma</li>
              <li>Cookies de consentimiento para recordar sus elecciones de privacidad</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">2. Cookies Analíticas</h3>
            <p className="mb-4">
              Nos ayudan a entender cómo los visitantes interactúan con nuestro sitio web, 
              proporcionando información sobre:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Número de visitantes y páginas vistas</li>
              <li>Tiempo de permanencia en el sitio</li>
              <li>Fuentes de tráfico</li>
              <li>Contenido más popular</li>
            </ul>
            <p className="mb-4">
              <strong>Servicios utilizados:</strong> Google Analytics (datos anonimizados)
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">3. Cookies de Marketing</h3>
            <p className="mb-4">
              Utilizadas para personalizar la experiencia y mostrar contenido relevante. Pueden incluir:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Seguimiento de intereses y preferencias</li>
              <li>Personalización de contenido académico</li>
              <li>Optimización de formularios y procesos de registro</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Gestión de cookies</h2>
            <p className="mb-4">
              Puede administrar sus preferencias de cookies en cualquier momento:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li>Utilizando nuestro banner de consentimiento</li>
              <li>A través del enlace "Configurar cookies" en el pie de página</li>
              <li>Modificando la configuración de su navegador</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Configuración del navegador</h2>
            <p className="mb-4">
              La mayoría de navegadores permiten controlar las cookies a través de su configuración:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li><strong>Chrome:</strong> Configuración → Privacidad y seguridad → Cookies</li>
              <li><strong>Firefox:</strong> Opciones → Privacidad y seguridad → Cookies</li>
              <li><strong>Safari:</strong> Preferencias → Privacidad → Cookies</li>
              <li><strong>Edge:</strong> Configuración → Cookies y permisos del sitio</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Datos personales y cookies</h2>
            <p className="mb-4">
              Las cookies pueden contener datos personales. Tratamos esta información de acuerdo con 
              nuestra <Link to="/aviso-privacidad" className="text-[#0b742f] hover:text-[#e87729] underline">
              Política de Privacidad</Link>.
            </p>
            <p className="mb-6">
              Los datos recopilados a través de cookies analíticas son anonimizados y utilizados 
              únicamente para fines estadísticos y de mejora del sitio web.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Cambios en esta política</h2>
            <p className="mb-6">
              Podemos actualizar esta Política de Cookies ocasionalmente. Los cambios significativos 
              serán notificados a través de nuestro sitio web.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Contacto</h2>
            <p className="mb-4">
              Si tiene preguntas sobre nuestra Política de Cookies, puede contactarnos:
            </p>
            <ul className="list-disc pl-6 mb-8">
              <li>Email: contacto@cenid.org</li>
              <li>Teléfono: +52 33 1061 8187</li>
              <li>Dirección: Centro de Estudios e Investigaciones para el Desarrollo Docente</li>
            </ul>

            <p className="text-sm text-gray-600 mt-8 pt-6 border-t border-gray-200">
              <strong>Última actualización:</strong> 23 de octubre de 2025
            </p>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200 flex justify-center">
            <Link 
              to="/" 
              className="inline-flex items-center px-6 py-3 bg-[#0b742f] text-white rounded-lg hover:brightness-95 transition-all"
            >
              Volver al inicio
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliticaCookies;